import apiClient from './apiClient';

const blogService = {
  // Get Blog Landing Page
  getBlogLanding: async () => {
    return apiClient.get('/blog');
  },

  // Get all blog posts (Public Grid)
  getBlogs: async (params = {}) => {
    return apiClient.get('/cms/blogs', params);
  },

  // Get Admin Blog List (All including drafts)
  getAdminBlogs: async (params = {}) => {
    return apiClient.get('/cms/admin/blogs', params);
  },


  // Get single blog post by slug (public)
  getBlogBySlug: async (slug) => {
    return apiClient.get(`/cms/blogs/${slug}`);
  },

  // Get single blog post by slug for admin (includes ID and all fields)
  getAdminBlogBySlug: async (slug) => {
    return apiClient.get(`/cms/admin/blogs/${slug}`);
  },

  // Create new blog (Uses CMS endpoint as blogs are in content_management)
  createBlog: async (data) => {
    return apiClient.post('/cms/pages', data);
  },

  // Update existing blog
  updateBlog: async (id, data) => {
    return apiClient.put(`/cms/pages/${id}`, data);
  },

  // Delete blog
  deleteBlog: async (id) => {
    return apiClient.delete(`/cms/pages/${id}`);
  }
};

export default blogService;
